import React from 'react'
import { RouteProps } from '../../routes/AppRouter'
import { ExternalRegister as ER } from 'features/external-register/'
import { useTitleHeaderContext } from '../../common/utils/TitleHeaderContext'
import { useSearchParams } from 'react-router-dom'
import i18n from 'i18n'
import { getLocaleFromLangType, LangType } from 'common/enums/LangType'

export function MarketplaceRegisterView(props: RouteProps) {
  const title = props.title || ''
  const [params] = useSearchParams()
  const language = params.get('lang')
  if (language) {
    const languageNumber = Number(language)
    i18n.changeLanguage(getLocaleFromLangType(languageNumber))
  }

  const { setTitle } = useTitleHeaderContext()
  setTitle(title)

  return (
    <>
      <ER token={window.location.pathname.split('/').pop() ?? ''} />
    </>
  )
}
